import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedList from 'I18n/components/FormattedList';
import { BreezeSingleStarIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { getBrandVoiceUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * How to find this component:
 * - Regate portal to Copilot:Collaborate
 * - Go to Editor and highlight some text
 * - Edit in left side panel rich text editor (not drag and drop main area)
 * - Do apply brand identity
 *
 * @deprecated - please import BrandVoiceMessage from ui-brand-identity-lib instead
 */
const BrandVoiceText = ({
  brandVoiceLinkKey,
  brandVoiceOptions
}) => {
  const {
    brandKitId,
    voiceChannel,
    voiceData
  } = brandVoiceOptions || {};
  const {
    tone,
    personality
  } = voiceData || {};
  const hasBrandVoiceData = tone && tone.length && personality && personality.length;
  if (!hasBrandVoiceData) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: brandVoiceLinkKey,
      elements: {
        UILink: Link
      },
      options: {
        href: getBrandVoiceUrl(brandKitId),
        external: true
      }
    });
  }
  const brandVoice = /*#__PURE__*/_jsx(Tooltip, {
    headingText: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "fill-accent-magenta-default",
        icon: BreezeSingleStarIcon,
        paddingInline: "0",
        marginInlineEnd: "100"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.header"
      })]
    }),
    title: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.voiceData_jsx",
        elements: {
          b: 'b',
          br: 'br'
        },
        options: {
          personality: /*#__PURE__*/_jsx(FormattedList, {
            twoWordsConnector: ", ",
            lastWordConnector: ", ",
            children: personality.map(personalityType => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.personalityTypes.${personalityType}`,
              options: {
                defaultValue: personalityType
              }
            }, personalityType))
          }),
          tone: /*#__PURE__*/_jsx(FormattedList, {
            twoWordsConnector: ", ",
            lastWordConnector: ", ",
            children: tone.map(toneType => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.toneTypes.${toneType}`,
              options: {
                defaultValue: toneType
              }
            }, toneType))
          })
        }
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.enabledForChannel.${voiceChannel || 'default'}`,
          options: {
            brandSettingsLink: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.brandSettingsLink_jsx",
              elements: {
                UILink: Link
              },
              options: {
                external: true,
                // For some reason clicking on the link was not working with just href,
                // so gotta manually open it with onClick
                onClick: () => {
                  window.open(getBrandVoiceUrl(brandKitId), '_blank');
                }
              }
            })
          }
        })
      })]
    }),
    use: "longform",
    children: /*#__PURE__*/_jsx(Link, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.label"
      })
    })
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "baseContentGenerationModal.inlineToolbar.brandVoice.usingBrandVoice",
    options: {
      brandVoice
    }
  });
};
export default BrandVoiceText;